import React from "react";
import { Button } from "@kitbird/core";
import Modal from "../../../../../components/Modal";
import VendorForm from "./VendorForm";
import useVendor from "../../useVendor";
import { IGetMasterVendorsData } from "../../../../../services/masterVendorService";

interface ModalVendorFormProps {
  isOpen: boolean;
  setClose: (modalState: boolean) => void;
  useCustomHook: ReturnType<typeof useVendor>;
}

const ModalVendorForm = ({
  isOpen, setClose, useCustomHook,
}: ModalVendorFormProps) => {
  const { methods, handlePost, editValues } = useCustomHook;
  return (
    <Modal
      isOpen={isOpen}
      setOpen={setClose}
      width={1160}
      title={`${editValues ? "Edit data" : "Tambah data"} - master vendor`}
      body={<div style={{
        margin: "-16px", overflowY: "auto", maxHeight: "70vh", padding: 16,
      }}>
        <VendorForm
          onClose={() => setClose(false)}
          useCustomHook={useCustomHook}
        />
      </div>}
      footer={
        <div className="action-container">
          <Button
            variant="text"
            type="button"
            onClick={() => setClose(false)}
          >
            Batal
          </Button>
          <Button
            onClick={methods.handleSubmit(
              () => { handlePost(); },
            )}
            disabled={!methods.formState.isValid}
          >
            Proses
          </Button>
        </div >
      }
    />
  );
};

export default ModalVendorForm;
